import type { HTMLAttributes } from 'react';
import { tlwTwMerge } from '@trg/utils';
import { Link } from '@trg/tlw-ui-component';
import { usePageData } from '@trg/api';

export type CopyrightProps = Omit<HTMLAttributes<HTMLDivElement>, 'children'>;

export function Copyright({ className, ...props }: CopyrightProps) {
  const serverIP = usePageData<string>('serverIP');
  return (
    <div
      className={tlwTwMerge(
        'tlw-txt-zh-mini tlw-text-txt-600 tlw-space-y-1',
        className
      )}
      {...props}
    >
      <p>特力屋股份有限公司 | 臺北市內湖區湖元里新湖三路23號1、2、5樓</p>

      <p>統一編號 | 89390488</p>

      <p title={serverIP || ''}>
        版權所有 | ©Copyright 2024 Test Rite Retail Co.,LTD. All Rights Reserved
      </p>

      <p>
        如您欲取消訂閱行銷訊息，請
        <Link
          className="tlw-underline tlw-underline-offset-4 tlw-duration-300 hover:tlw-text-txt-core"
          href="https://www.trplus.com.tw/my-account/onlineContactform"
        >
          聯絡客服
        </Link>
        為您確認身分後再行取消
      </p>
    </div>
  );
}
